import get from 'lodash.get';

export const getCandidateDetails = ({ candidateOverview }) => (get(candidateOverview, 'data', {}));
export const getCandidateInsights = ({ candidateOverview }) => (get(candidateOverview, 'data.insights.parameters', {}));
